module.exports = __webpack_public_path__ + "062cac54932cf1c6ed4a91ddc4f410ed.svg";